import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'

const styles = () => ({
  wrap: {
    position: 'relative',
    display: 'inline-flex',
    maxWidth: '100%',
  },
  select: {
    height: 48,
    padding: '0 40px 0 var(--careco-space-md)',
    background: 'var(--careco-surface)',
    color: 'var(--careco-text-primary)',
    border: '1px solid var(--careco-border)',
    borderRadius: 'var(--careco-rounded-sm)',
    fontFamily: 'var(--careco-font)',
    fontSize: 14,
    fontWeight: 500,
    cursor: 'pointer',
    outline: 'none',
    width: '100%',
    appearance: 'none',
    WebkitAppearance: 'none',
    MozAppearance: 'none',
    '&::-ms-expand': { display: 'none' },
    '&:hover': { borderColor: 'var(--careco-primary)' },
    '&:focus-visible': {
      outline: '2px solid var(--careco-primary)',
      outlineOffset: 2,
    },
  },
  active: {
    borderColor: 'var(--careco-primary)',
    background: 'var(--careco-primary-light)',
    fontWeight: 600,
  },
  chevron: {
    position: 'absolute',
    right: 'var(--careco-space-md)',
    top: '50%',
    transform: 'translateY(-50%)',
    pointerEvents: 'none',
    display: 'flex',
    color: 'var(--careco-icon-default)',
  },
  '@media (max-width: 600px)': {
    wrap: {
      width: '100%',
      display: 'flex',
    },
  },
})

const FilterSelect = ({ classes, value, onChange, options, label, allLabel = 'All' }) => (
  <span className={classes.wrap}>
    <select
      className={`${classes.select} ${value !== 'all' ? classes.active : ''}`}
      value={value}
      aria-label={label}
      onChange={event => onChange(event.target.value)}>
      <option value="all">{allLabel}</option>
      {options.map(option => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
    <span className={classes.chevron} aria-hidden="true">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
        <path
          d="M6 9l6 6 6-6"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  </span>
)

FilterSelect.propTypes = {
  classes: PropTypes.object.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  label: PropTypes.string.isRequired,
  allLabel: PropTypes.string,
}

export default withStyles(styles)(FilterSelect)
